// ============================================
// Notification API Service
// ============================================

import api from './api';

const notificationService = {
    getNotifications: (params) => api.get('/notifications', { params }),
    markAsRead: (id) => api.patch(`/notifications/${id}/read`),
    markAllAsRead: () => api.patch('/notifications/read-all'),
};

export default notificationService;
